import React from "react";
import { X } from "lucide-react";
import { Button } from "components/ui/button";

const InvoiceModal = ({
  isOpenInvoiceModal,
  setIsOpenInvoiceModal,
  invoices,
}) => {

  return (
    <>
      {isOpenInvoiceModal && (
        <div
          style={{ zIndex: 9999 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div className="bg-card w-[484px] max-w-md shadow-lg px-[42px] py-[56px] relative">
            <button
              type="button"
              aria-label="Close"
              className="absolute top-4 right-5 text-muted-foreground hover:text-foreground"
              onClick={() => setIsOpenInvoiceModal(false)}
            >
              <X className="w-4 h-4" />
            </button>

            <h2 className="text-xl font-semibold mb-[34px]">Monthly Invoice</h2>

            <div className="border-t !text-sm border-border pt-4 space-y-4">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Due Date</span>

                <span className="text-muted-foreground">Invoice Number </span>
              </div>

              <div className="flex justify-between">
                <span>
                  {invoices?.dueDate || new Date().toLocaleDateString()}
                </span>

                <span className="font-medium">{invoices?.id || "000000"}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-muted-foreground">Status</span>
                <span className="text-muted-foreground">Payment Method</span>
              </div>

              <div className="flex justify-between">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-medium">
                  {invoices?.status}
                </span>

                <span>{invoices?.default_payment_method || "Unknown"}</span>
              </div>

              <hr className="mt-2 " />

              <div className="flex justify-between">
                <span className="text-muted-foreground text-[12px]">Plan</span>
              </div>

              <div className="flex justify-between">
                <span className="text-muted-foreground">Starter</span>
                <span>${invoices?.amount_due || 0}</span>
              </div>

              <hr className="my-2" />

              <div className="flex justify-between">
                <span className="text-muted-foreground">Taxes</span>
                <span>${invoices?.tax || 0}</span>
              </div>

              <hr className="my-2" />

              <div className="flex justify-between font-semibold">
                <span className="text-foreground">Total</span>
                <span>${invoices?.amount_due + invoices?.tax || 0}</span>
              </div>
            </div>

            <div className="mt-6 flex justify-center">
              <Button asChild className="w-full">
                <a
                  href={invoices?.invoice_pdf}
                  target="_blank"
                  download={`invoice_${invoices?.id || "000000"}.pdf`}
                  className="cursor-pointer w-full text-center"
                  rel="noreferrer"
                >
                  Download PDF
                </a>
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceModal;
